import { useEffect, useRef, useState } from 'react'
import { Button, Stack } from '@mui/material'
import { Box } from '@mui/system'
import { Item } from '../../../common/snippets'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import { focusElemnt, navigation3 } from '../../../common/helper'
import { useAtom } from 'jotai'
import { companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { getcolumnDefs, HeaderColumn, summaryColumnDefs, summaryUserWiseColumnDefs, TOPAY_AS_COD_HEADER_MAP, TRANSACTION_LABEL_MAP } from './constants'
import { formatPaymentSummaryTable, formatUserWiseSummaryTable, groupDetailedTable } from './utilFucntions'
import { RenderTable } from '../analysisReport/summmaryTable'
import { exportToExcel, useAutoResizeHeight } from '../../../common/hook'
import { makeTable } from '../analysisReport/pdfAutotable'
import { divideInNIntegers } from '../../../common/mathHelper'
import { TableComponent } from '../../../common/TableComponent'
var totalPagesExp = '{total_pages_count_string}'
const reportName = 'Userwise Collection'
export const ReportTable = ({
  disableExcel,
  userDetail,
  tableData,
  tableData1,
  tableData2,
  loginData,
  selBranch,
  UserName,
  fromDate,
  toDate,
  transaction,
  paymentMode,
  paymentType,
  isSummary,
  isSummaryUserWise,
  tableData4,
  AllowPrintandPdf
}) => {
  const [showTableData, setShowTableData] = useState([])
  const [searchResult, setSearchResult] = useState(true)
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const [companySettings] = useAtom(companySettingsAtom)
  const { UseFormattedLRinReports, IsConvCharge, DefaultCurrencyID, UseToPayAsCOD } = companySettings
  const { generatePDF, load } = { ...state }
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
  const columnDefs = getcolumnDefs(UseFormattedLRinReports, DefaultCurrencyID, TRANSACTION_LABEL_MAP.BKNG)
  const columnDefsDEL = getcolumnDefs(UseFormattedLRinReports, DefaultCurrencyID, TRANSACTION_LABEL_MAP.DEL)
  const columnDefsRFND = getcolumnDefs(UseFormattedLRinReports, DefaultCurrencyID, TRANSACTION_LABEL_MAP.RFND)
  const span1 = divideInNIntegers(columnDefs.length, 2)
  const headers = summaryUserWiseColumnDefs.map((col) => ({
      ...col,
      align: col.align || col.xlCol?.dataType === 'quantity' ? 'right' : 'left',
      exportHead: col.header,
    }))
  const summaryheader =
    UseToPayAsCOD !== 1
      ? summaryColumnDefs
      : summaryColumnDefs
          .filter((col) => col.field !== 'CODAmt')
          .map((col) => ({
            ...col,
            header: TOPAY_AS_COD_HEADER_MAP[col.field] ?? col.header,
          }))
  const header1 = [
    [
      { header: `Report For: ${reportName} Report`, field: '', span: span1[0], mainHeader: true },
      { header: `Company Name : ${loginData.strCompanyName}`, field: '', span: span1[1] },
    ],
  ]
  useEffect(() => {
    if (tableData?.length > 0) {
      let data = []
      if (isSummary) {
        data = formatPaymentSummaryTable(tableData1, UserName, userDetail, summaryheader)
      }else if(isSummaryUserWise) {
        data = formatUserWiseSummaryTable(tableData4, UserName, userDetail, summaryUserWiseColumnDefs)
      } else {
        data = groupDetailedTable(tableData, UserName, IsConvCharge, tableData2, userDetail, columnDefs, columnDefsDEL, columnDefsRFND)
      }
      setShowTableData(data)
    } else {
      setShowTableData([])
    }
  }, [tableData])
  const tableRef = useRef()
  useAutoResizeHeight(tableRef, 20, true)
  const headerList = [selBranch?.BranchName, UserName, transaction?.Transactions, paymentType?.name, paymentMode?.ModeName]
  const HeaderColumns = HeaderColumn.map((col) => {
    return { header: col.header, dataKey: col.field, xlCol: col.xlCol }
  })
  const HeaderData = [
    HeaderColumn.reduce(
      (acc, curr) => {
        acc[curr.field] = headerList.shift()
        return acc
      },
      { dataType: 'entry' }
    ),
  ]
  const customFunction = (data, doc) => {
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(18).setFont('Roboto', 'bold')
    doc.text(
      `Collection Date: ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')} `,
      data.settings.margin.left,
      150
    )
    doc.text(`Report View: Summary`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
  }
  const customFunction2 = (data, doc) => {
    doc.setTextColor(40)
    doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
    doc.setFontSize(26).setFont('Roboto', 'bold')
    doc.setTextColor(16, 79, 162)
    doc.text(`Cargo System | ${reportName} Report`, 30 + 60, 80)
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(22).setFont('Roboto', 'bold')
    doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
    jsPdfHeaderFooter(data, loginData, totalPagesExp)
  }
  const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
    const doc = data.doc
    // Footer
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

    var str = 'Page : ' + doc.internal.getNumberOfPages()
    if (typeof doc.putTotalPages === 'function') {
      str = str + ' of ' + totalPagesExp
    }
    doc.setFontSize(16)
    doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, 'right')
    doc.setFont('Roboto', 'bold')
    doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
    doc.text(
      `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
      doc.internal.pageSize.width / 2 -
        (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) / 2 +
        90,
      pageHeight - 5
    )
  }
  const printClick = (isSave) => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const pdfColumns = (isSummary ? summaryheader : columnDefs).map((col) => {
      return { header: col?.headerName, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'p', format: [1239, 1754], unit: 'px', compress: true })

    doc.setProperties({
      title: `${reportName}.pdf`,
      subject: `${reportName} Report`,
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    makeTable(doc, autoTable, HeaderColumns, HeaderData, 1, reportName, loginData, 'everyPage', customFunction, 170)
    makeTable(doc, autoTable, pdfColumns, showTableData, 1, reportName, loginData, 'never', customFunction2)

    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`${reportName} Report ${currentDateTime}.pdf`)
    }
    setTimeout(() => {
      setState({ ...state, generatePDF: false, load: true })
      const pdfUrl = doc.output('bloburl')
      document.getElementById('userWiseCollectionoutput').data = pdfUrl
      // document.getElementById('userWiseCollectionoutput').data = doc.output('datauristring', `${reportName}.pdf`)
      focusElemnt('UWBackBtn')
    }, 2000)
  }
  return (
    <>
      {isSummaryUserWise ? <>
        <TableComponent
          reportName={reportName}
          criteriaHeaders={HeaderColumn}
          criteriaData={HeaderData}
          tableData={showTableData}
          mainHeader={headers}
          hideHeader={true}
        />
      </> :
        <>
          <Stack style={{ margin: '0px 10px', marginRight: '0px' }}>
            <Item className="userReport">
              <Item className="userReport-heading">Report For:{reportName} Report</Item>
              <Item className="userReport-buttons">
                {searchResult ? (
                  <>
                    <Box>
                      <Button
                        variant="outlined"
                        className="userWisereporttembtn"
                        disabled={disableExcel}
                        onClick={() =>
                          exportToExcel({
                            fileName: `${reportName} ${currentDateTime}.xlsx`,
                            sheetName: reportName,
                            headersList: [header1, HeaderColumn, isSummary ? summaryheader : columnDefs],
                            dataList: [[], HeaderData, showTableData],
                            showHeader: false,
                          })
                        }
                      >
                        Export to Excel
                      </Button>
                    </Box>

                    <Box>
                      <Button
                        id="UWExpToPdfBtn"
                        variant="outlined"
                        className="userWisereporttembtn"
                        disabled={!AllowPrintandPdf}
                        onClick={() => {
                          setSearchResult(false)
                          printClick(true)
                        }}
                        onKeyDown={(e) =>
                          navigation3(e, 'UWPrintPdfBtn', disableExcel ? 'UWSplitButton' : 'UWExpToExsl', () => {
                            setSearchResult(false)
                            printClick(true)
                          })
                        }
                      >
                        Export to Pdf
                      </Button>
                    </Box>
                    <Box>
                      <Button
                        id="UWPrintPdfBtn"
                        variant="outlined"
                        className="userWisereporttembtn"
                        onClick={() => {
                          setSearchResult(false)
                          printClick(false)
                        }}
                        onKeyDown={(e) =>
                          navigation3(e, 'UWFromDate', 'UWExpToPdfBtn', () => {
                            setSearchResult(false)
                            printClick(false)
                          })
                        }
                        disabled={!AllowPrintandPdf}
                      >
                        Print
                      </Button>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box>
                      <Button
                        id="UWBackBtn"
                        variant="outlined"
                        className="userWisereporttembtn"
                        onClick={() => {
                          setSearchResult(true)
                        }}
                        onKeyDown={(e) =>
                          navigation3(e, 'UWFromDate', 'UWSplitButton', () => {
                            setSearchResult(true)
                            focusElemnt('UWSplitButton')
                          })
                        }
                      >
                        Back
                      </Button>
                    </Box>
                  </>
                )}
              </Item>
            </Item>
          </Stack>
          {searchResult ? (
            <>
              <Stack
                ref={tableRef}
                sx={{ marginLeft: 2, marginRight: 2, paddingTop: '0px', paddingBottom: '16px', overflowX: 'scroll' }}
                className="userwise-collection-table"
              >
                <RenderTable
                  data={showTableData}
                  bodyFontSize="12px"
                  header={isSummary ? summaryheader : columnDefs}
                  key1="ss3fe"
                  key2="e4r32s"
                  key3="sde343"
                  showHeader={false}
                  datacolStyle={{ padding: '6px 8px' }}
                />
              </Stack>
            </>
          ) : (
            <>
              {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
              {load ? (
                <object
                  id="userWiseCollectionoutput"
                  type="application/pdf"
                  width={'100%'}
                  height="440"
                  title="MTLPL -Cargo System - After Transfer Summary Report"
                  aria-label="MTLPL -Cargo System - After Transfer Summary Report"
                ></object>
              ) : (
                ''
              )}
            </>
          )}
        </>
      }
    </>
  )
}
